import axios from "axios";

export const getFormConfig = () =>
  axios.get("/api/form-config").then((response) => response.data);
